import PopupAddCustomer from './PopupAddCustomer';

export default PopupAddCustomer;
